import { IAction } from '../sagas';
import { REMOVE_POST_SUCCESS, UPDATE_POST_SUCCESS, ADD_POST_SUCCESS, REQUEST_POSTS_SUCCESS, UPDATE_LIKE_SUCCESS, UPDATE_LIKE_COUNT_SUCCESS, ADD_COMMENT_SUCCESS, REMOVE_COMMENT_SUCCESS, CHECK_PENDING_POSTS_SUCCESS, POSTS_REORDER_SUCCESS } from '../handlers.actions';

const initPostsStore: any = () => ([]);

/** POSTS REDUCER */
export const postReducer = (state = initPostsStore(), action: IAction) => {
    switch (action.type) {
         case ADD_POST_SUCCESS:
              return [
                   ...state.slice(0, action.payload),
                   action.payload,
                   ...state.slice(action.payload)
              ];

         case UPDATE_POST_SUCCESS:               
              return state.map((post: any) => {
                   if (post._id === action.payload._id) {
                        return action.payload;
                   }
                   return post;
              });
              
          case UPDATE_LIKE_SUCCESS:               
               return state.map((post: any) => {
                    if (post._id === action.payload._id) {
                         return action.payload;
                    }
                    return post;
               });

          case UPDATE_LIKE_COUNT_SUCCESS:               
               return state.map((post: any) => {
                    if (post._id === action.payload._id) {
                         return action.payload;
                    }
                    return post;
               });

         case REMOVE_POST_SUCCESS:               
              return state.filter((post: any) => post._id !== action.payload);

     //     case REQUEST_POST_SUCCESS:
     //          return [
     //               ...state.slice(0, action.payload),
     //               action.payload,
     //               ...state.slice(action.payload)
     //          ];

          case ADD_COMMENT_SUCCESS:
               return state.map((post: any) => {
                    if (post._id === action.payload.post._id) {
                         return action.payload.post;
                    }
                    return post;
               });

          case REMOVE_COMMENT_SUCCESS:               
              return state.map((post: any) => {
                    if (post._id === action.payload.post._id) {
                         return action.payload.post;
                    }
                    return post;
               });

         case REQUEST_POSTS_SUCCESS:              
              return [ ...action.payload];
         case POSTS_REORDER_SUCCESS:
              return [...action.payload];
         default:
              return state;
    }
};


const initPendingPostsStore: any = () => ([]);

export const pendingPostReducer = (state = initPendingPostsStore(), action:IAction) => {
     const {type, payload} = action;
     switch(type){
          case CHECK_PENDING_POSTS_SUCCESS:
               return [...payload];
          case UPDATE_POST_SUCCESS:       
               if(!payload.isApproved) {
                    return state.map((post: any) => {
                         if (post._id === payload._id) return payload;
                         return post;
                    });
               } else {
                    return state.filter((post: any) => post._id !== payload._id);
               }   
               
          default:
               return state;
     }
}